__turbopack_context__.v({
  "accommodationName": "_0HRk6W_accommodationName",
  "basketImageWrapper": "_0HRk6W_basketImageWrapper",
  "bookingDetails": "_0HRk6W_bookingDetails",
  "editButton": "_0HRk6W_editButton",
  "flexContent": "_0HRk6W_flexContent",
  "flexContentGap12": "_0HRk6W_flexContentGap12",
  "flexContentGap16": "_0HRk6W_flexContentGap16",
  "flexContentGap4": "_0HRk6W_flexContentGap4",
  "flexContentGap8": "_0HRk6W_flexContentGap8",
  "flexContentRow": "_0HRk6W_flexContentRow",
  "location": "_0HRk6W_location",
  "overviewContent": "_0HRk6W_overviewContent",
});
